import { render, staticRenderFns } from "./shenPiReformCatalog.vue?vue&type=template&id=5c9268fe"
import script from "./shenPiReformCatalog.vue?vue&type=script&lang=js"
export * from "./shenPiReformCatalog.vue?vue&type=script&lang=js"
import style0 from "./shenPiReformCatalog.vue?vue&type=style&index=0&id=5c9268fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports